(function () {
  'use strict';

  function rootUrl(section) {
    var value = section.dataset.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return value.endsWith('/') ? value : value + '/';
  }

  function elements(card) {
    return {
      form: card.querySelector('[data-spc-form]'),
      select: card.querySelector('[data-spc-variant-select]'),
      input: card.querySelector('[data-spc-variant-input]'),
      button: card.querySelector('[data-spc-add-button]'),
      buttonText: card.querySelector('[data-spc-button-text]'),
      price: card.querySelector('[data-spc-price]'),
      compare: card.querySelector('[data-spc-compare-price]'),
      saleBadge: card.querySelector('[data-spc-sale-badge]'),
      image: card.querySelector('.wanted-product-carousel__image'),
      message: card.querySelector('[data-spc-message]')
    };
  }

  function selectedOption(parts) {
    return parts.select ? parts.select.options[parts.select.selectedIndex] : null;
  }

  function variantId(parts) {
    if (parts.select) return parts.select.value;
    return parts.input ? parts.input.value : '';
  }

  function setMessage(parts, text, isError) {
    if (!parts.message) return;
    parts.message.textContent = text || '';
    parts.message.classList.toggle('is-error', Boolean(isError));
  }

  function setButton(parts, available) {
    if (!parts.button) return;
    parts.button.disabled = !available;
    if (parts.buttonText) {
      parts.buttonText.textContent = available
        ? (parts.button.dataset.defaultText || 'ADD TO CART')
        : (parts.button.dataset.soldOutText || 'SOLD OUT');
    }
  }

  function updateVariant(card) {
    var parts = elements(card);
    var option = selectedOption(parts);
    if (!option) return;

    var available = option.dataset.available !== 'false';
    var onSale = option.dataset.onSale === 'true';

    if (parts.price && option.dataset.price) {
      parts.price.textContent = option.dataset.price;
    }

    if (parts.compare) {
      parts.compare.textContent = onSale ? (option.dataset.comparePrice || '') : '';
      parts.compare.classList.toggle('is-hidden', !onSale);
    }

    if (parts.saleBadge) {
      parts.saleBadge.classList.toggle('is-hidden', !onSale);
    }

    if (parts.image && option.dataset.image) {
      parts.image.src = option.dataset.image;
      parts.image.removeAttribute('srcset');
      parts.image.removeAttribute('sizes');
      parts.image.alt = option.dataset.imageAlt || parts.image.alt || '';
    }

    setButton(parts, available);
    setMessage(parts, '', false);
  }

  async function fallbackAdd(section, id) {
    var response = await fetch(rootUrl(section) + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }]
      })
    });

    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.description || data.message || 'Unable to add this product.');
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

    if (section.dataset.openCartAfterAdd === 'true') {
      if (window.WantedCart && typeof window.WantedCart.refresh === 'function') {
        await window.WantedCart.refresh();
      }
      if (window.WantedCart && typeof window.WantedCart.open === 'function') {
        await window.WantedCart.open();
      }
    }

    return data;
  }

  async function addToCart(section, id) {
    if (section.dataset.openCartAfterAdd === 'true' && window.WantedCart && typeof window.WantedCart.add === 'function') {
      return window.WantedCart.add(id, 1, {});
    }
    return fallbackAdd(section, id);
  }

  function initCard(section, card) {
    if (!card || card.dataset.spcReady === 'true') return;
    card.dataset.spcReady = 'true';

    var parts = elements(card);
    if (!parts.form || !parts.button) return;

    if (parts.select) {
      parts.select.addEventListener('change', function () {
        updateVariant(card);
      });
    }

    parts.form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();

      var id = variantId(parts);
      if (!id || parts.button.disabled || parts.button.dataset.busy === 'true') return;

      parts.button.dataset.busy = 'true';
      parts.button.disabled = true;
      parts.button.classList.remove('is-added', 'is-error');
      parts.button.classList.add('is-loading');
      setMessage(parts, '', false);

      if (parts.buttonText) {
        parts.buttonText.textContent = parts.button.dataset.loadingText || 'ADDING...';
      }

      try {
        await addToCart(section, id);
        parts.button.classList.remove('is-loading');
        parts.button.classList.add('is-added');

        if (parts.buttonText) {
          parts.buttonText.textContent = parts.button.dataset.addedText || 'ADDED';
        }

        window.setTimeout(function () {
          parts.button.classList.remove('is-added');
          parts.button.dataset.busy = 'false';
          if (parts.select) {
            updateVariant(card);
          } else {
            setButton(parts, true);
          }
        }, 1000);
      } catch (error) {
        parts.button.classList.remove('is-loading');
        parts.button.classList.add('is-error');
        parts.button.dataset.busy = 'false';
        parts.button.disabled = false;

        if (parts.buttonText) {
          parts.buttonText.textContent = parts.button.dataset.errorText || 'TRY AGAIN';
        }

        setMessage(parts, error && error.message ? error.message : 'Unable to add this product.', true);

        window.setTimeout(function () {
          parts.button.classList.remove('is-error');
          if (parts.select) {
            updateVariant(card);
          } else {
            setButton(parts, true);
          }
        }, 1800);
      }
    });

    if (parts.select) updateVariant(card);
  }

  function initGrid(section) {
    if (!section || section.dataset.spcSectionReady === 'true') return;
    section.dataset.spcSectionReady = 'true';

    section.querySelectorAll('[data-spc-card]').forEach(function (card) {
      initCard(section, card);
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wanted-product-grid]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
